import _ from "underscore";
import $ from "jquery";
import Backbone from "backbone";
import {pathname} from "../others/Configuration";

export default Backbone.Model.extend({
  url: null,

  buildURL: function(options) {
    // TODO refactor
    return pathname + '/api' + (this.url || "");
  },

  /**
   * @return {[type]}
   */
  getEnvironment: function(options) { { } },

  /**
   * Build and return the AJAX call parameters
   *
   * @returns {Object}
   */
  buildParams: function(options) {
    var formattedOptions = options || {};

    return {
      url: this.buildURL(formattedOptions),
      type: 'post',
      dataType: formattedOptions.dataType || 'json',
      contentType: 'application/json',
      data: JSON.stringify(this.getEnvironment(formattedOptions)),
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      xhrFields: { withCredentials: true }
    };
  },

  fetch: function(options) {
    var params = this.buildParams(options);

    $.ajax(params).then(
      response => {
        this.setFromAPI(response, options);
      },
      responseError => {
        this.setErrorFromAPI(responseError, options);
      }
    );
  },

  update: function() {
    this.fetch();
  },

  setFromAPI: function(response, options) { },
  setErrorFromAPI: function(responseError, options) { },
});
